import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { useState } from "react";
import React from "react";
import * as Constants from "../constants";
import ReactModal from "react-modal";
import AfvalRequest from "../elements/afvalrequest";
import axios from "axios";

//import Notifications, {notify} from 'react-notify-toast';

interface IFraction {
  id: string;
  name: string;
}

interface IFractions extends Array<IFraction> {}

interface IItem extends Constants.IItem {}

interface IItems extends Constants.IItems {}

let cancelFractions: any = null;

const Street = (props: any) => {
  const locale = "nl";

  let id = props.match.params.id;
  let debid = props.match.params.debid;
  // let debid = "test";
  let today: Date = new Date();
  let firstDay: Date = new Date(today.getFullYear() - 1, today.getMonth(), 1);
  let selectedDate: any = props.match.params.date
    ? new Date(props.match.params.date)
    : null;
  let existing: boolean = props.match.params.existing
    ? props.match.params.existing === 1
    : true;
  let fraction: string = props.match.params.fraction
    ? props.match.params.fraction
    : "";
  let slot: string = props.match.params.slot ? props.match.params.slot : "";

  const [sStreetid, setStreetid] = useState(id);
  const [sDebid, setDebid] = useState(debid);
  const [sDate, setDate] = useState(selectedDate);
  const [sFractionid, setFractionid] = useState(fraction);
  const [sExisting, setExisting] = useState(existing);
  const [sFractions, setFractions] = useState<IFractions>([]);
  const [sList, setList] = useState<IItems | undefined>([]);
  const [sSlot, setSlot] = useState(slot);
  const [sReservation, setReservation] = useState(null);
  const [sListMessage, setListMessage] = useState(<></>);
  const [sFilter, setFilter] = useState("");

  React.useEffect(() => {
    if (!selectedDate) {
      if (!selectedDate || selectedDate <= today) {
        selectedDate = today;
      }
      if (!sDate) {
        setDate(selectedDate);
      } else if (sDate < today) {
        setDate(today);
      }
      getFracties();
      createUrl();
    } else if (sFractions?.length === 0) {
      getFracties();
    }
  });

  if (sStreetid !== id) {
    setStreetid(id);
  }
  if (sDebid !== debid) {
    setDebid(debid);
  }

  function getFracties() {
    if (cancelFractions) {
      //cancelFractions.cancel("new request");
    }

    cancelFractions = axios.CancelToken.source();

    //setFractions(nFractions);
    return Constants.api
      .get("/React/recyclingpoint/fractions?id=" + id, {
        cancelToken: cancelFractions.token,
      })
      .then((response: any) => {
        let nFractions: IFractions = [];

        response?.data?.Result?.forEach((fraction: any) => {
          let nFraction: IFraction = {
            id: fraction.Id,
            name: fraction.Naam,
          };

          nFractions.push(nFraction);
        });

        setFractions(nFractions);
        setFractionid(
          nFractions.find((fraction) => fraction.id === sFractionid)?.id ??
            nFractions[0].id
        );
      })
      .catch(function (error) {
        setFractions([]);
      });
  }

  let cancelList: any = null;

  function getList() {
    if (cancelList) {
      cancelList.cancel("new request");
    }
    //cancelList.cancel();

    let nItems: IItems = [];
    setList(nItems);
    setListMessage(<span className="list-loading">Laden...</span>);
    if (sFractionid === "") {
      setListMessage(
        <span className="list-nofraction">
          Om een nieuwe reservering te kunnen maken of om een bestaande
          reservering te kunnen inzien, dient u eerst de juiste afvalsoort te
          selecteren.
        </span>
      );
      return;
    }
    cancelList = axios.CancelToken.source();
    if (sExisting) {
      return Constants.api
        .get(
          "/React/recyclingpoint/reservations?id=" +
            id +
            //"&FractieId=" +
            //sFractionid +
            "&date=" +
            Constants.tryFormat(sDate, "dd-MM-yyyy"),
          { cancelToken: cancelList.token }
        )
        .then((response: any) => {
          //
          let prevtime: Date;
          response?.data?.Result?.forEach((reservation: any) => {
            let slot = reservation.SelectedTimeslot;
            var extensie = "";
            if (reservation.Extensie) {
              extensie = reservation.Extensie;
            }
            let ctimetitle: any = null;
            if (!prevtime || prevtime !== slot.StartTijd) {
              ctimetitle = Constants.tryFormat(slot.StartTijd, "HH:mm");
              console.log(ctimetitle, slot);
            }
            let nItem: IItem = {
              id: slot.Id,
              reservationid: reservation.Id,
              timefrom: slot.StartTijd,
              timetitle: ctimetitle,
              available: slot.BeschikbarePlaatsen,
              description: `${reservation.Postcode} ${reservation.HuisNummer} ${extensie}`,
              customername: reservation.Naam,
              existing: true,
              done: reservation?.Visited ?? false,
              fraction: reservation?.FractieId ?? "",
            };
            nItems.push(nItem);
            prevtime = slot.StartTijd;
          });
          setList(nItems);
          if (nItems.length === 0) {
            setListMessage(
              <span className="list-noresults">Geen resultaten</span>
            );
          } else {
            setListMessage(<></>);
          }
          if (nItems.length > 0 && sFilter !== "") {
            setTimeout(function () {
              searchText();
            }, 0);
          }
        });
    } else {
      return Constants.api
        .get(
          "/React/recyclingpoint/timeslots?id=" +
            id +
            "&fractionId=" +
            sFractionid +
            "&startDate=" +
            Constants.tryFormat(sDate, "dd-MM-yyyy"),
          { cancelToken: cancelList.token }
        )
        .then((response: any) => {
          //
          response?.data?.Result?.forEach((date: any) => {
            date.TimeSlots?.forEach((slot: any) => {
              var SlotAantal = "plek";
              if (slot.BeschikbarePlaatsen > 1) {
                SlotAantal = "plekken";
              }
              let nItem: IItem = {
                id: slot.Id,
                timefrom: slot.StartTijd,
                available: slot.BeschikbarePlaatsen,
                description:
                  slot.BeschikbarePlaatsen > 0
                    ? " " + SlotAantal + " beschikbaar"
                    : "Geen plekken beschikbaar",
                existing: false,
                done: false,
              };
              nItems.push(nItem);
            });
          });
          var results = document.getElementById("results");
          if (results) {
            results.style.minHeight = "initial";
          }
          setList(nItems);
          if (nItems.length === 0) {
            setListMessage(
              <span className="list-noresults">Geen resultaten</span>
            );
          } else {
            setListMessage(<></>);
          }
        });
    }
  }

  function createUrl(slot?: string) {
    let formatSelectedDate = Constants.tryFormat(sDate, "yyyy-MM-dd");
    let formatExisting = sExisting ? "1" : "0";
    props.history.push({
      pathname:
        `/street/${sStreetid}/${sDebid}/${formatSelectedDate}/${formatExisting}/${sFractionid}` +
        (slot && slot !== "" ? "/" + slot : ""),
    });
  }

  function displayDate() {
    if (!sDate) {
      return;
    }
    var intDay = sDate.getDay() - 1;
    return (
      Constants.WEEKDAYS_LONG["nl"][intDay === -1 ? 6 : intDay] +
      " " +
      Constants.tryFormat(sDate, "d") +
      " " +
      Constants.MONTHS["nl"][sDate.getMonth()] +
      " " +
      Constants.tryFormat(sDate, "yyyy")
    );
  }

  React.useEffect(() => {
    createUrl();
    getList();
  }, [sDate, sFractionid, sExisting]);

  React.useEffect(() => {
    if (sExisting) {
      document.body.classList.remove("nonexisting");
      document.body.classList.add("existing");
    } else {
      document.body.classList.add("nonexisting");
      document.body.classList.remove("existing");
    }
  }, [sExisting]);

  React.useEffect(() => {
    createUrl(sSlot);
  }, [sSlot]);

  React.useEffect(() => {}, [sList]);

  function handleCloseModal() {
    setSlot("");
    createUrl(sSlot);

    var results = document.getElementById("results");
    if (results) {
      results.style.minHeight = results.offsetHeight + "px";
    }
    getList();
  }

  if (slot !== sSlot) {
    //setSlot(slot);
    //createUrl(slot);
  }

  function handleListClick(e: any) {
    let el = e.currentTarget;
    console.log(el);
    console.log(el.dataset);
    if (el.classList.contains("empty") && !el.dataset.reservationid) {
      return;
    }

    setSlot(el.dataset.id);

    if (el.dataset.reservationid) {
      setReservation(el.dataset.reservationid);
    }
  }

  function handleDoneClick(e: any) {
    //e.preventDefault();
    e.stopPropagation();

    //setSlot(el.dataset.id);
    var input = e.target;

    let listItem = input.closest("li");
    console.log("click:", listItem.dataset.reservationid, input.checked);
    Constants.api
      .post(
        `/React/recyclingpoint/MarkReservation?ReservationId=${
          listItem.dataset.reservationid
        }&Visited=${input.checked ? "true" : "false"}`
      )
      .then((response: any) => {
        let data = response.data;
        if (data?.Success === true) {
          listItem.setAttribute("data-done", input.checked);
          Constants.ga4react.initialize().then((ga4) => {
            ga4.event(
              "User checked reservation",
              "Checked",
              input.checked.toString()
            );
          });
        } else {
          input.checked = !input.checked;
        }
      });
  }

  function handleFractionClick(e: any) {
    setFractionid(e.currentTarget.value);
  }

  function handleDayClick(day: any, modifiers: any) {
    if (modifiers.disabled) {
      return;
    }
    if (!modifiers.selected) {
      setDate(day);
    }
  }

  function searchText() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("searchInput") as HTMLInputElement;
    if (input) {
      filter = input.value.toUpperCase();

      setFilter(filter);

      ul = document.getElementById("results") as HTMLUListElement;
      var found = 0;
      if (ul) {
        //if(ul.classList.contains(""))
        li = ul.getElementsByTagName("li");

        // Loop through all list items, and hide those who don't match the search query
        for (i = 0; i < li.length; i++) {
          a = li[i];
          txtValue = a.innerText;
          txtValue += txtValue.replace(/\s/g, "");
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
            found += 1;
          } else {
            li[i].style.display = "none";
          }
        }
        if (found === 0) {
          setListMessage(<span className="list-noresults">Niks gevonden</span>);
        } else {
          setListMessage(<></>);
        }
      }
    }
  }

  let straatitem = document.querySelector(".mainmenu .active");
  let straat = "";
  if (straatitem) {
    straat = straatitem.innerHTML;
  }

  const FORMAT = "dd-MM-yyyy";

  return (
    <>
      <section className="timesection">
        <h2>Geselecteerde datum</h2>
        <div className="DayPicker">
          <DayPickerInput
            inputProps={{ readOnly: true }}
            format={FORMAT}
            value={Constants.tryFormat(sDate, FORMAT)}
            formatDate={(date, format) => Constants.tryFormat(date, format)}
            dayPickerProps={{
              disabledDays: [firstDay, { after: firstDay, before: today }],
              onDayClick: handleDayClick,
              initialMonth: sDate,
              selectedDays: sDate,
              showWeekNumbers: true,
              months: Constants.MONTHS[locale],
              weekdaysLong: Constants.WEEKDAYS_LONG[locale],
              weekdaysShort: Constants.WEEKDAYS_SHORT[locale],
              firstDayOfWeek: Constants.FIRST_DAY_OF_WEEK[locale],
              labels: Constants.LABELS[locale],
              todayButton: "Vandaag",
            }}
          />
          <span className="dayPickerIcon">
            <img src="/img/icons/18px_calendar.svg" alt="Kalender" />
          </span>
        </div>
        <h1>
          {straat} -{" "}
          <span id="datum" className="lc_txt">
            {displayDate()}
          </span>
        </h1>
      </section>
      <section className="tabsheader">
        <button
          onClick={(e) => {
            setExisting(true);
          }}
          className={sExisting ? "active" : ""}
        >
          Bestaande reservering
        </button>
        <button
          onClick={(e) => {
            setExisting(false);
          }}
          className={!sExisting ? "active" : ""}
        >
          Nieuwe reservering maken
        </button>
      </section>
      <section className="scheduler">
        <div id="fractions">
          {!sExisting &&
            sFractions?.map((Fraction, i) => (
              <label
                key={i}
                className={
                  "fraction" + (sFractionid === Fraction.id ? " active" : "")
                }
              >
                <input
                  type="radio"
                  name="fraction"
                  value={Fraction.id}
                  checked={sFractionid === Fraction.id}
                  onChange={handleFractionClick}
                />
                {Fraction.name}
              </label>
            ))}
          <label className="searchfield">
            {sExisting && sList && sList.length > 0 && (
              <div className="search">
                <span>
                  <img src="/img/icons/18px_search.svg" alt="Kalender" />
                </span>
                <input
                  type="text"
                  id="searchInput"
                  onKeyUp={searchText}
                  placeholder="Zoek op postcode of naam"
                />
              </div>
            )}
          </label>
        </div>
      </section>
      <section className="appointments">
        <ul
          id="results"
          className={
            (sExisting ? "existing" : "new") +
            " " +
            (sFilter !== "" ? "filtered" : "notfiltered")
          }
        >
          {sList?.map((Item, i) => (
            <>
              {Item.timetitle ? (
                <li className="time-title">{Item.timetitle}</li>
              ) : (
                ""
              )}
              <li
                className={Item.available === 0 ? "item empty" : "item"}
                key={i}
                onClick={handleListClick}
                data-id={Item.id}
                data-done={Item.done}
                data-reservationid={Item.reservationid}
              >
                {sExisting && (
                  <label className="done" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      data-id={Item.id}
                      defaultChecked={Item.done}
                      onChange={handleDoneClick}
                    />
                    <div className="d-input" />
                  </label>
                )}
                <span className="time">
                  {Constants.tryFormat(Item.timefrom, "HH:mm")}
                </span>
                {!sExisting && (
                  <span className="available">
                    {Item.available === 0 ? "" : Item.available}
                  </span>
                )}
                <span className="address">{Item.description}</span>
                <span className="customername">{Item.customername}</span>
                <span className="edit">
                  {sExisting
                    ? "Bewerken"
                    : Item.available === 0
                    ? ""
                    : "Reserveer plek"}
                </span>
                <span className="fraction">
                  {sFractions.find(
                    (sFraction) => sFraction.id === Item.fraction
                  )?.name ?? ""}
                </span>
              </li>
            </>
          ))}
          {sListMessage}
        </ul>
      </section>
      <ReactModal
        isOpen={sSlot && sSlot !== "" ? true : false}
        contentLabel="onRequestClose Example"
        onRequestClose={handleCloseModal}
        appElement={document.getElementById("root") as HTMLElement}
      >
        <button onClick={handleCloseModal} className="modalBack">
          X Sluiten
        </button>
        <AfvalRequest
          street={sStreetid}
          slot={sSlot}
          fractionId={sFractionid}
          slotId={sSlot}
          reservationId={sReservation}
          debId={sDebid}
          date={sDate}
          existing={sExisting}
          close={handleCloseModal}
        ></AfvalRequest>
      </ReactModal>
    </>
  );
};
export default Street;